import Model from 'flarum/common/Model';
// A single shout. Registered with app.store as the 'shouts' type so reads,
// creates and deletes go through the store (cached, reactive, user sideloaded)
// instead of hand-built requests.
export default class Shout extends Model {
  content = Model.attribute('content');
  canDelete = Model.attribute('canDelete');
  createdAt = Model.attribute('createdAt', Model.transformDate);
  user = Model.hasOne('user');
}
flarum.reg.add('swtorpolska-shoutbox', 'forum/models/Shout', Shout);